import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    value: {
      type: [String, Number, Object, Boolean, Array],
      default: ''
    }
  },
  computed: {
    internalValue: {
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // Mixins are deprecated, this will be removed eventually so this will remain so as not to break the existing API
      get(): any {
        return this.value;
      },

      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // Mixins are deprecated, this will be removed eventually so this will remain so as not to break the existing API
      set(value: any) {
        this.$emit('input', value);
      }
    }
  }
});
